import { IIconProps } from './icon';

interface IIconDoubleRightArrowProps extends IIconProps {
  fill?: string;
}

export const IconDoubleRightArrow = ({
  style = {},
  cy,
  fill = '#FFFFFF',
}: IIconDoubleRightArrowProps) => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconFiltersMap${cy}`}
    >
      <path d="M2.10875 0.75L0.875 1.98375L4.8825 6L0.875 10.0163L2.10875 11.25L7.35875 6L2.10875 0.75Z" />
      <path d="M7.875 0.75L6.64125 1.98375L10.6488 6L6.64125 10.0163L7.875 11.25L13.125 6L7.875 0.75Z" />
    </svg>
  );
};
